import DefaultLayout, { ILayoutProps } from './default';

const OffersLayout: React.FC<ILayoutProps> = ({ children, isAuth }) => {
    return (
        <div className="bg-blueGray-100">
            <DefaultLayout isAuth={isAuth}>{children}</DefaultLayout>
        </div>
    );
};

export default OffersLayout;
